import { Controller } from 'stimulus';

export default class extends Controller {
    static targets = [ 'container', 'circle' ];
    static values = { score: Number };

    connect() {
        this.loadCircle(this.scoreValue);
    }

    loadCircle(score) {
        const circle = this.circleTarget;
        const container = this.containerTarget;

        let initialOffset = -440;
        let calc = -(initialOffset + ((score/5) * initialOffset));
        circle.style['stroke-dasharray'] = -initialOffset;
        circle.style['stroke-dashoffset'] = calc;

        container.classList.toggle('hidden');
    }

}
